import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import WeightAdjustmentSwitcher from './../../components/WeightAdjustmentSwitcher/WeightAdjustmentSwitcher';
import * as actionTypes from './../../store/actions/weightAdjustmentAction';
import * as helpActionTypes from './../../store/actions/helpAction';
import fetchWeightAdjustmentAction from './../../store/actions/fetch/fetchWeightAdjustmentAction';
import Loader from './../../components/Loader/Loader'

/**
 * Weight Adjustment container
 */
class WeightAdjustment extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selected, onSelect, defaultValues,
      ready, readyCriticalCare, selectedCriticalCare, openModalWithContent, casuistic, selectedBCS} = this.props;
    // If there is a need for default data
    if(!ready && !error && !pending && readyCriticalCare) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher

    return (
      <div className='nppe2-fc-weight-adjustment-switcher__wrapper'>
        {error && <span className='nppe2-fc-weight-adjustment-switcher__error'>{error}</span>}
        {!error &&
        <WeightAdjustmentSwitcher
          data={data}
          selected={selected}
          onSelect={onSelect}
          selectedCriticalCare={selectedCriticalCare}
          openModalWithContent={openModalWithContent}
          casuistic={casuistic}
          selectedBCS={selectedBCS}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.weightAdjustmentReducer.selected,
    error: state.weightAdjustmentReducer.error,
    data: state.weightAdjustmentReducer.data,
    pending: state.weightAdjustmentReducer.pending,
    ready: state.weightAdjustmentReducer.ready,
    selectedCriticalCare: state.criticalCareReducer.selected,
    readyCriticalCare: state.criticalCareReducer.ready,
    casuistic: state.calculateDerReducer.data.casuistic,
    selectedBCS: state.conditionScoreReducer.selected
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchWeightAdjustmentAction
      },
      dispatch,
    ),
    onSelect: (id) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    openModalWithContent: (key) => dispatch({
      type: helpActionTypes.OPEN_MODAL_WITH_CONTENT,
      key: key,
      open: true,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(WeightAdjustment);
